const LeaderboardSection = () => {

  const leaderboard = [
      { rank: 1, name: 'GamerAce_ID', game: 'Valorant', rank_game: 'Radiant', ping: '3ms' },
      { rank: 2, name: 'ProMLBB_99', game: 'Mobile Legends', rank_game: 'Mythical Glory', ping: '5ms' },
      { rank: 3, name: 'CS2_Legend', game: 'CS2', rank_game: 'Global Elite', ping: '4ms' },
      { rank: 4, name: 'PUBGMaster', game: 'PUBG Mobile', rank_game: 'Conqueror', ping: '6ms' },
      { rank: 5, name: 'GenshinPro', game: 'Genshin Impact', rank_game: 'AR 60', ping: '8ms' }
    ];

return (
   <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl sm:text-5xl font-black text-center mb-16">
              <span className="bg-gradient-to-r from-blue-400 to-blue-400 bg-clip-text text-transparent">
                Top Gamers Leaderboard
              </span>
            </h2>

            <div className="bg-gray-800/60 backdrop-blur-md rounded-2xl border border-gray-700 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-500 to-blue-500 p-4">
                <h3 className="text-xl font-bold text-center text-gray-900">🏆 Hall of Fame - Telnet Gamers</h3>
              </div>
              
              <div className="p-6">
                {leaderboard.map((player, index) => (
                  <div key={index} className="flex items-center justify-between p-4 mb-3 last:mb-0 bg-gray-700/30 rounded-lg border border-gray-600 hover:border-cyan-500/50 transition-all duration-300">
                    <div className="flex items-center space-x-4">
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${
                        index === 0 ? 'bg-blue-500 text-gray-900' :
                        index === 1 ? 'bg-gray-400 text-gray-900' :
                        index === 2 ? 'bg-blue-500 text-white' :
                        'bg-gray-600 text-white'
                      }`}>
                        {player.rank}
                      </div>
                      
                      <div>
                        <div className="font-bold text-white">{player.name}</div>
                        <div className="text-sm text-gray-400">{player.game} - {player.rank_game}</div>
                      </div>
                    </div>
                    
                    <div className="text-right">
                      <div className="text-green-400 font-bold">{player.ping}</div>
                      <div className="text-xs text-gray-400">avg ping</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
    );
};
export default LeaderboardSection;